import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../auth/user.service";
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: "app-public-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {

  showMenu = true;
  loggedIn = false;
  selectedLanguage = localStorage.getItem('lang') || 'en';
  items: any[] | undefined;
  activeItem: MenuItem | undefined;

  constructor(
    private readonly userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.loggedIn = this.userService.user !== undefined;
  }

  ngOnInit(): void {
    this.items = [
      { label: 'Inicio', route: '/', icon: 'pi pi-fw pi-home' },
      { label: 'Inmuebles', route: '/buildings', icon: 'pi pi-fw pi-building' },
      { label: 'Nosotros', route: '/about', icon: 'pi pi-fw pi-users' },
      { label: 'Preguntas frecuentes', route: '/faqs', icon: 'pi pi-fw pi-tags' }
    ];
    this.activeItem = this.items.find((item) => item.route === this.activatedRoute.snapshot['_routerState'].url);

  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  onChangeLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
    window.location.reload();
  }

  onActiveItemChange(event: any) {
    this.router.navigate([event.route]);
  }


}
